module.exports = __webpack_public_path__ + "img/116004.6feb3afc.png";